import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { RepprovalReason } from 'models/repprovalReason';

import { Container, Items, Item } from './styles';

interface Props {
  show: boolean;
  value: any;
  reasons: RepprovalReason[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: RepprovalReason) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectGroups = ({ show, reasons, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useStoreTranslation();

  const isReasonActive = useCallback((item: RepprovalReason) => item === value, [value]);

  const handleItemClick = (reason: RepprovalReason) => {
    if (reason !== value) {
      onChange(reason);
    }
    onClose();
  };

  return show ? (
    <Container>
      <Items>
        {reasons &&
          reasons.map((c) => (
            <MakeItem
              key={c.id}
              className={isReasonActive(c) ? 'active' : ''}
              text={c.name}
              onClick={() => handleItemClick(c)}
            />
          ))}
      </Items>
    </Container>
  ) : null;
};

export default SelectGroups;
